import {
  computed,
  Directive,
  HostBinding,
  input,
  numberAttribute,
} from '@angular/core';

@Directive({
  selector: '[wfNotificationsStackItem]',
  host: {
    // Expose depth as a CSS custom property
    '[style.--depth]': 'depth()',
    '[style.z-index]': 'zIndex()',
  },
})
export class WfNotificationsStackItemDirective {
  readonly depth = input(0, {
    alias: 'wfNotificationsStackItem',
    transform: numberAttribute,
  });

  // Keep visual stacking order: smaller depth (newer) should be on top
  protected readonly zIndex = computed(() => 2000 - this.depth());
}
